import React from 'react'
import PropTypes from 'prop-types'

const COLOR_VARIANTS = ['info', 'success', 'warning', 'error']

const HelloBar = ({ descrizione, descrizione_mobile, color, url, blank }) => {
  const desktopText = descrizione?.trim()
  const mobileText = (descrizione_mobile || descrizione)?.trim()

  if (!desktopText && !mobileText) return null

  const variant = COLOR_VARIANTS.includes(color) ? color : 'info'
  const target = blank ? '_blank' : undefined
  const rel = blank ? 'noopener noreferrer' : undefined

  const content = (
    <>
      {desktopText && (
        <span className="hello-bar__text hello-bar__text--desktop" title={desktopText}>
          {desktopText}
        </span>
      )}
      {mobileText && (
        <span className="hello-bar__text hello-bar__text--mobile" title={mobileText}>
          {mobileText}
        </span>
      )}
    </>
  )

  const classes = `hello-bar hello-bar--${variant}${url ? ' hello-bar--is-link' : ''}`

  return url ? (
    <a href={url} target={target} rel={rel} className={classes}>
      {content}
    </a>
  ) : (
    <div className={classes}>{content}</div>
  )
}

HelloBar.propTypes = {
  descrizione: PropTypes.string,
  descrizione_mobile: PropTypes.string,
  color: PropTypes.string,
  url: PropTypes.string,
  blank: PropTypes.bool,
}

export default HelloBar
